import { useState } from 'react';
import JourneyForm from './JourneyForm';
import JourneyList from './JourneyList';

const JourneyManagement = () => {
  const [view, setView] = useState('list'); // 'list' or 'form'
  const [editingJourney, setEditingJourney] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleEdit = (journey) => {
    setEditingJourney(journey);
    setView('form');
  };

  const handleSuccess = () => {
    setEditingJourney(null);
    setRefreshKey(prev => prev + 1);
    setView('list');
  };

  const handleCancel = () => {
    setEditingJourney(null);
    setView('list');
  };

  const handleNewJourney = () => {
    setEditingJourney(null);
    setView('form');
  };

  return (
    <div className="journey-management">
      <div className="content-header">
        <h1>Journey Management</h1>
        <button onClick={handleNewJourney} className="btn-primary">
          + New Journey
        </button>
      </div>

      <div className="content-body">
        {view === 'form' ? (
          <JourneyForm
            editingJourney={editingJourney}
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />
        ) : (
          <JourneyList
            onEdit={handleEdit}
            onRefresh={refreshKey}
          />
        )}
      </div>
    </div>
  );
};

export default JourneyManagement;